export const intervalInSeconds = (seconds) => seconds * 1000;
